import { render, staticRenderFns } from "./WithdrawalRecord.vue?vue&type=template&id=42222535&"
import script from "./WithdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./WithdrawalRecord.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalRecord.vue?vue&type=style&index=0&id=42222535&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports